import { isNumber } from '@web/shared/utils/core.util'

export const formatRealNumber = (
  value: number,
  precision = 5,
  lower = 1e-3,
  upper = 1e6
): string => {
  if (!isNumber(value)) return 'Не определено'
  if (value === 0) return '0'

  const abs = Math.abs(value)

  if (abs <= lower || abs >= upper) {
    const exponent = Math.floor(Math.log10(abs))
    const mantissa = value / Math.pow(10, exponent)
    const formatted = Number(mantissa.toPrecision(precision))
    const sign = exponent >= 0 ? '+' : ''
    return `${formatted}e${sign}${exponent}`
  }

  return Number.parseFloat(value.toPrecision(precision)).toString()
}
